<template>
    <div class="px-3 py-2">
        <p class="d-block mb-2">We'd like to keep you informed by email about relevant exclusive offers and services from ENSO.</p>
        <span class="fa-preload" data-fa-detect-icon>
            <i class="fa-light fa-square fa-xl"></i>
            <i class="fa-light fa-square-check fa-xl"></i>
        </span>
        <label for="marketing" class="cursor-pointer d-flex gap-3 align-items-center align-items-sm-start" :class="{'active': denyMarketing}">
            <i
                class="fa-xl fa-light mt-0 mt-sm-3"
                :class="denyMarketing ? 'fa-square-check' : 'fa-square'"
            ></i>
            <input type="checkbox" id="marketing" class="cursor-pointer" name="marketing" v-model="denyMarketing" @change="toggleMarketing()">
            <p class="mb-0">Please tick the box if you <b>do not</b> want to receive any of these communications.</p>
        </label>
    </div>
</template>

<script>
    import basketFunctions from "@shared/mixins/basket";
    export default {
        mixins: [basketFunctions],
        props: ['basket'],
        data() {
            return {
                updatedBasket: this.basket,
                denyMarketing: (this.updatedBasket?.marketing == null || this.updatedBasket?.marketing == '1' ? false : true)
            }
        },
        computed: {
        },
        mounted() {
            this.emitter.on('updateBasket', data => {
                this.updatedBasket = data;
            });
        },
        methods: {
            toggleMarketing: function() {
                let vm = this;
                axios.post('/ajax/toggle_marketing/' + (vm.denyMarketing ? 0 : 1))
                .then(response => {
                    vm.updatedBasket = response.data.basket;
                })
                .catch(error => {
                    console.error("There was an error!", error);
                });
            },
        }
    };
</script>

<style lang="scss" scoped>
    label {
        input {
            display: none;
        }
    }
    .fa-preload {
        position: absolute;
        width: 0;
        height: 0;
        overflow: hidden;
        opacity: 0;
        pointer-events: none;
    }
</style>